module.exports = __webpack_public_path__ + "img/bg-magento-find-out.9d6c8e6d.webp";